import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from "@angular/common";
import { ConfirmPopupComponent } from './confirm-popup/confirm-popup.component';
import { EsriMapComponent } from './map-component/esri.map.component';
import { TranslateModule } from '@ngx-translate/core';
import { AccessDeniedComponent } from './access-denied/access-denied.component';
import { GeneralModalComponent } from './general-modal/general-modal.component';
import { MultiSelectComponent } from './multi-select/multi-select.component';
import { TransactionsComponent } from './transactions/transactions.component';
import { RouterModule } from '@angular/router';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { NgxPaginationModule } from 'ngx-pagination';
import { MatDialogModule } from '@angular/material/dialog';
import { MatAutocompleteModule } from '@angular/material/autocomplete';


@NgModule({
  declarations: [
    ConfirmPopupComponent,
    EsriMapComponent,
    AccessDeniedComponent,
    GeneralModalComponent,
    ConfirmPopupComponent,
    MultiSelectComponent,
    TransactionsComponent
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    TranslateModule,
    RouterModule,
    //OwlDateTimeModule,
    //OwlNativeDateTimeModule,
    MatDatepickerModule,
    MatNativeDateModule,
    //MatMomentDateModule,
    NgxPaginationModule,
    MatDialogModule,
    MatAutocompleteModule,
  ],
  exports: [
    ConfirmPopupComponent,
    EsriMapComponent,
    AccessDeniedComponent,
    GeneralModalComponent,
    ConfirmPopupComponent,
    MultiSelectComponent,
    TransactionsComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedComponentsModule { }
